export default __webpack_public_path__ + "static/media/formQuestionImage.df5740e3.png";